import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { safeHref } from "../../lib/safeHref";
import { formatIban } from "../../lib/formatIban";

const GiftSection = ({
  giftMessage,
  giftIban,
  giftIbanHolder,
  giftRegistryUrl,
  ...rest
}) => {
  const { t } = useTranslation();
  const safeRegistryUrl = safeHref(giftRegistryUrl);

  const [copied, setCopied] = useState(false);

  const handleCopyIban = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(giftIban);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Silently fail
    }
  };

  return (
    <section className="section home-testi" {...rest}>
      <div className="container">
        <div className="quote-div">
          <div className="pad-15">
            <p className="made-36">{t("home.gifts.heading")}</p>
            <p className="made-28">{giftMessage}</p>
          </div>
          <div className="vert-line _10vh mbm-exclusion"></div>

          {giftIban && (
            <div style={{ marginTop: "25px" }}>
              {giftIbanHolder && (
                <p
                  className="signature"
                  style={{ marginTop: 0, marginBottom: "8px" }}
                >
                  {giftIbanHolder}
                </p>
              )}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <span
                  className="signature"
                  style={{
                    marginTop: 0,
                    letterSpacing: "1.5px",
                    fontSize: "16px",
                    lineHeight: 1,
                  }}
                >
                  {formatIban(giftIban)}
                </span>
                <button
                  onClick={handleCopyIban}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    opacity: 0.5,
                    transition: "opacity 0.2s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.5")}
                  title={copied ? t("home.gifts.copySuccess") : t("home.gifts.copyPrompt")}
                >
                  {copied ? (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  ) : (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          )}

          {safeRegistryUrl && (
            <div style={{ marginTop: giftIban ? "20px" : "25px" }}>
              <p
                className="signature"
                style={{ marginTop: 0, marginBottom: "10px" }}
              >
                {t("home.gifts.registryPrompt")}
              </p>
              <a
                href={safeRegistryUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="signature"
                style={{
                  marginTop: 0,
                  opacity: 0.7,
                  borderBottom: "1px solid currentColor",
                  textDecoration: "none",
                  transition: "opacity 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.7")}
              >
                {t("home.gifts.registryLink")}
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default GiftSection;
